import { FC } from 'react'
import cls from '../styles/Help.module.scss'
import { HeaderBar } from '@/components/HeaderBar'
import { Footer } from '@/components/Footer'
import { SEO } from '@/components/SEO'
import { GetServerSideProps } from 'next'

interface SSP {
  insideTeams: boolean
}

/* eslint-disable */
const Help: FC<SSP> = ({ insideTeams }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="How to use Delayed Send for Microsoft Teams | Help & FAQ" 
        description="Learn how to schedule, edit, and cancel delayed messages in Microsoft Teams. Get help with premium features like file attachments and recurring messages."
        keywords="Microsoft Teams, delayed messages, help, support, schedule messages, premium features"
      />
      <HeaderBar showLogOutButton={false} className={insideTeams ? '!hidden' : ''} />
      <div className={`${cls.help} flex-grow`}>
        <h1>How to Use Delayed Send</h1>

        <p>
          <i>Delayed Send</i> is a Microsoft Teams app that lets you schedule messages for
          later delivery.
        </p>

        <h2>How do I send a delayed message?</h2>

        <p>
          In order to schedule a delayed message, you can use the chat messaging
          extensions, the app dashboard, or the external website.
        </p>

        <h3>1) Chat compose extension</h3>
        <p>
          When you are in the desired Teams chat, click the <i>Delayed Send</i> icon below
          the chat box. This will bring up a popup view that lets you indicate what to say
          in your message, and when to send it.
        </p>

        <h3>2) App dashboard</h3>
        <p>
          If you open the "Apps" view in Microsoft Teams and select <i>Delayed Send</i>,
          you will see a <i>Dashboard</i> tab. In this view there is a button that lets
          you schedule messages. You will have to choose the destination chat, as well as
          the message content and delivery date/time.
        </p>

        <h3>3) External web app</h3>
        <p>
          If you prefer so, you can open &nbsp;
          <a href="https://delayedsend.com/app" target="_blank">
            https://delayedsend.com/app
          </a>
          &nbsp; using your favorite browser. Once you login, you will see the same
          options as in the dashboard above.
        </p>

        <h2>How can I see, edit and cancel scheduled messages?</h2>
        <p>
          You can open the <i>Delayed Send</i> dashboard or web app as described above.
          There you will see a sorted list of scheduled messages, which you would be able
          to edit, reschedule or cancel as needed.
        </p>

        <h2>How much does it cost?</h2>
        <p>
          <i>Delayed Send</i> offers a free plan with basic features that let you schedule up to 3 simultaneously scheduled messages. 
          We also offer premium plans that include unlimited messages, file attachments, recurring messages, and more.
        </p>
        <p>
          Visit our <a href="/pricing">pricing page</a> to learn more about our Pro and Team plans.
        </p>

        <h2>Can I share some feedback?</h2>
        <p>
          Absolutely! Visit our &nbsp;
          <a href="/contact-us">
            contact page
          </a>
          &nbsp; and let us know what you have in mind. We love feedback! Even if it
          sometimes hurts.
        </p>
      </div>
      <Footer />
    </div>
  )
}

export default Help

export const getServerSideProps: GetServerSideProps<SSP> = async (context) => {
  return {
    props: {
      insideTeams: !!context.query.teamsEmail,
    },
  }
}